import IService from "@api/iService";
import {
    ConsumerBonusCode,
    ConsumerBonusCodeFull,
    ConsumerBonusCodesList,
    ConsumerBonusCodeUse
} from "@interfaces/consumer/bonusCodes";
import { PanelTableData } from "@interfaces/panel";
import { ConsumerAddBonusCodesModel, ConsumerPatchBonusCodeModel } from "@models/consumer/bonusCodes";
import { PanelTableDataModel } from "@models/panel";

export default class ConsumerBonusService extends IService {

    getBonusCodesList(model: PanelTableDataModel) {
        return this.postApi<PanelTableData<ConsumerBonusCode[]>>('/api/consumer/bonus/', model);
    }

    async putConsumerBonusCodes(codes: ConsumerAddBonusCodesModel) {
        return await this.putApi<ConsumerBonusCode[]>('/api/consumer/bonus/', codes);
    }

    async patchBonusCode(model: ConsumerPatchBonusCodeModel) {
        return await this.patchApi<ConsumerBonusCodesList>('/api/consumer/bonus/', model);
    }
    
    async getBonusCode(id: string) {
        return await this.getApi<ConsumerBonusCodeFull>(`/api/consumer/bonus/${id}/`);
    }

    fetchBonusCodeUsesList = async (id: string, model: PanelTableDataModel) => {
        return await this.postApi<PanelTableData<ConsumerBonusCodeUse[]>>(`/api/consumer/bonus/${id}/uses/`, model);
    }
}